import { PageHeader } from '@organisms';
import { Space } from 'antd';
import { FC } from 'react';

import { BannerStepper } from './BannerStepper';

interface BannerStepHeaderProps {
  currentStep: number;
  onChangeStep: (value: number) => void;
  title: string;
  subtitle: string;
  backToPath: string | (() => void);
  stepsCompleted: Record<'configuration' | 'content' | 'schedule', boolean>;
  stepsWithErrors: Record<'configuration' | 'content' | 'schedule', boolean>;
}

export const BannerStepHeader: FC<BannerStepHeaderProps> = ({
  currentStep,
  onChangeStep,
  title,
  subtitle,
  backToPath,
  stepsCompleted,
  stepsWithErrors,
}) => {
  return (
    <Space direction='vertical' size={'large'} style={{ width: '100%' }}>
      <PageHeader
        backToPath={backToPath}
        title={title}
        subTitle={subtitle}
        hasDivider={false}
      />

      <BannerStepper
        currentStep={currentStep}
        onChangeStep={onChangeStep}
        stepsCompleted={stepsCompleted}
        stepsWithErrors={stepsWithErrors}
      />
    </Space>
  );
};
